import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { MODULE, GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath, DELETE, LIST } from '../api/ApiConst';
import apiCaller from "../api/ApiCaller";

export const Module = {
  basePath: "module",
  tableDataUrl:LIST,
  label: "Module",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "Name", value: "name", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  {
    name: "Module", value: "parentModuleId", type: "select", position: 2, formAttribute: true, isStatic: false, basePath: "module",
    dataListFunction: () => {
      const options = []
      var jsonRequest = { "page": 0, "size": 200, searchFilters: [], sortRules: [] };
      apiCaller.callPostApi(getApiPath(MODULE, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
      response.data.map((d) => {
          options.push({ value: d.value, label: d.key })
        });
      }, (error) => {
        console.error(error);
      });
      return options
    }
  },
  { name: "Url", value: "url", type: "text", position: 3, formAttribute: true, className: "form-control input-default" },
  { name: "Default Value", value: "byDefault", type: "checkbox", i: 4, formAttribute: true, className: "form-control input-default" }
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(MODULE, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



